/*세팅 값*/
export const COOL_TIME = 1;
export const TIME_DURATION = 60; // 게임 시간
export const TIME_OFFSET = 5; //
export const RESULT_TIME = 20; // 결과창 보는시간
